import LegalLayout from "./LegalLayout";

export default function Privacidad() {
  return (
    <LegalLayout title="Política de Privacidad">
      <p>En Dentainhoa nos tomamos muy en serio la protección de tus datos personales. Esta política explica qué información recopilamos, con qué finalidad y cuáles son tus derechos, en cumplimiento del <strong>Reglamento (UE) 2016/679 (RGPD)</strong> y la <strong>LOPDGDD 3/2018</strong>.</p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li>Ainhoa Pilar Quinga Parrales (Dentainhoa)</li>
        <li>Email: dentainhoa@gmail.com · Teléfono: +34 641 712 904</li>
      </ul>

      <h2>2. Datos que recopilamos</h2>
      <ul>
        <li><strong>Formulario de reserva:</strong> nombre, email, teléfono, dirección, servicio deseado, fecha, hora y notas.</li>
        <li><strong>Datos de pago:</strong> gestionados exclusivamente por Stripe. Nunca almacenamos números de tarjeta.</li>
        <li><strong>Datos técnicos:</strong> IP, navegador y páginas visitadas mediante cookies (ver Política de Cookies).</li>
      </ul>

      <h2>3. Finalidad</h2>
      <ul>
        <li>Gestionar la reserva y prestación del servicio.</li>
        <li>Enviar confirmaciones y recordatorios de la cita.</li>
        <li>Cumplir obligaciones legales y fiscales.</li>
      </ul>

      <h2>4. Base legal</h2>
      <p>El tratamiento se basa en el <strong>consentimiento</strong> del usuario al enviar el formulario y en la <strong>ejecución del contrato</strong> de prestación del servicio.</p>

      <h2>5. Destinatarios</h2>
      <ul>
        <li><strong>Stripe Inc.</strong> — procesamiento de pagos.</li>
        <li><strong>Resend Inc.</strong> — envío de emails de confirmación.</li>
        <li>No cedemos tus datos a terceros con fines comerciales.</li>
      </ul>

      <h2>6. Conservación</h2>
      <p>Conservamos los datos durante el tiempo necesario para prestar el servicio y cumplir las obligaciones legales (facturación, contabilidad, 5-6 años).</p>

      <h2>7. Tus derechos</h2>
      <p>Puedes ejercer tus derechos de <strong>acceso, rectificación, supresión, oposición, limitación y portabilidad</strong> escribiendo a <a href="mailto:dentainhoa@gmail.com" className="underline">dentainhoa@gmail.com</a>. También puedes reclamar ante la <strong>Agencia Española de Protección de Datos</strong> (aepd.es).</p>

      <h2>8. Seguridad</h2>
      <p>Aplicamos medidas técnicas y organizativas adecuadas (cifrado TLS, acceso restringido) para proteger tus datos.</p>

      <p className="text-xs opacity-70 mt-8">Última actualización: julio de 2026.</p>
    </LegalLayout>
  );
}
